var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<table class=\"table table-responsive\"><thead><th>Name</th><th>URL Name</th><th class=\"text-right\"><button ng-click=\"vm.toggleMenuSelector()\" class=\"btn btn-primary btn-xs\">{{vm.menuSelectorLabel || 'Add Menu'}}</button></th></thead><tbody><tr ng-repeat=\"item in vm.docSvc.doc.groupMenus track by $index\"><td>{{item.menuId.name ? item.menuId.name : item.title}}</td><td>{{item.referenceName}}</td><td style=\"padding: 4px;\"><list-item-buttons id-val=\"item.menuId._id\" delete-fn=\"vm.deleteGroupMenu(idVal)\" edit-fn=\"vm.editMenuInGroup(idVal, item)\" details-fn=\"vm.detailsLink(idVal)\"></list-item-buttons></td></tr></tbody></table>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/production/menugroups/tabs/tab-menus.jade
// module id = 194
// module chunks = 0